export default "__VITE_ASSET__HipcsPXS__"